import { render } from "./ViewApropos.vue?vue&type=template&id=405d3230&ts=true"
import script from "./ViewApropos.vue?vue&type=script&lang=ts"
export * from "./ViewApropos.vue?vue&type=script&lang=ts"

import "./ViewApropos.vue?vue&type=style&index=0&id=405d3230&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__